import { render, staticRenderFns } from "./BtnPaymentMethod.vue?vue&type=template&id=4d508bb3&"
import script from "./BtnPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./BtnPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports